import { z } from 'zod';

// Boro's bulk case/service-ticket endpoints reject requests where
// atm_ids.length + location_ids.length > 100 - keep the client in sync with that limit.
export const MAX_BULK_TARGETS = 100;

// Shown once a chip resolves, so the user can confirm they entered the right machine/location.
export const targetPreviewSchema = z.object({
  title: z.string(),
  subtitle: z.string().optional(),
  meta: z.string().optional(),
});

// A single chip in the "Enter Machine / Location IDs" flow.
// type is resolved asynchronously (a raw ID is looked up as a machine, then a location)
// so the user never has to say up front which kind of ID they're entering.
export const targetChipSchema = z.object({
  type: z.enum(['atm', 'location']).nullable(),
  value: z.string(),
  status: z.enum(['validating', 'valid', 'invalid']),
  error: z.string().optional(),
  preview: targetPreviewSchema.optional(),
  // The location a resolved 'atm' chip belongs to. Tickets are location-scoped, not
  // machine-scoped, so consumers that create location-keyed entities (e.g. service tickets)
  // need this to fold multiple machines at the same location into a single target.
  resolvedLocationId: z.number().nullable().optional(),
});

export type TargetType = NonNullable<z.infer<typeof targetChipSchema>['type']>;
export type TargetChip = z.infer<typeof targetChipSchema>;
